import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  useEffect(() => {
    // Skip the /me check while returning from the Google OAuth callback.
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    if (!getToken()) { setUser(false); return; }
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => { clearToken(); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const googleExchange = async (sessionId) => {
    const { data } = await api.post("/auth/google", { session_id: sessionId });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const logout = () => { clearToken(); setUser(false); };

  return <AuthContext.Provider value={{ user, login, register, googleExchange, logout }}>{children}</AuthContext.Provider>;
};
